// AdminList
export const SET_ADMIN_LIST = 'SET_ADMIN_LIST'
export const SET_DISABLED_ADMIN_LIST = 'SET_DISABLED_ADMIN_LIST'
export const SET_ADMIN_STATUS = 'SET_ADMIN_STATUS'
export const SET_ZENTAO_URL = 'SET_ZENTAO_URL'
export const SET_ALL_ROLE = 'SET_ALL_ROLE'
export const SET_SEARCH_ROLE = 'SET_SEARCH_ROLE'
export const SET_ADMIN_IS_OUTSIDE = 'SET_ADMIN_IS_OUTSIDE'

// AgentList
export const SET_AGENT_LIST = 'SET_AGENT_LIST'
export const SET_AGENT_SEARCHING = 'SET_AGENT_SEARCHING'

// organizationList
export const SET_ORGANIZATION_LIST = 'SET_ORGANIZATION_LIST'

// permission
export const UPDATE_PERMISSION_LIST = 'UPDATE_PERMISSION_LIST'
